
import React, {useState, useEffect} from 'react';

import GLOBALS from '../elements/Globals';
import Loader from '../elements/Loader';
import { Link } from 'react-router-dom';

const createMarkup = (htmlString) => {
  return { __html: htmlString };
};

const FightSeheduleBoxing = (props) => {

  const [loading, setLoading] = useState(false);
  const [pagedata, setPagedata ]= useState("");

  useEffect(() => {
    setLoading(true)
    async function getData() {
      let apiUrl = 'cmspage?page_id=contact-us';
      const url = GLOBALS.API_BASE_URL+apiUrl;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
        const json = await response.json();
        setPagedata(json.data.content);
        setLoading(false)
      } catch (error) {
        console.error(error.message);
      }
    }
    getData();
    return () => {
      // Cleanup logic here
    };
  }, []);

  
  return (

    <>
    
    <div className="mvpBgContainer mvp_container" id="newsMainContent" style={{width: '100%'}}>
       <div className="news_articles_content" style={{width: '100%'}}>
  <div className="left_content_area odds_section">
    <h1 className="titles_article sch_title">Boxing Fight Schedule 2025 | MVP Boxing</h1>{/* ends (.sch_title) */}
    <ul className="sch_tabs">
      <li className="ative_tab"><Link to="/fights-schedule/boxing">Boxing</Link></li>
      <li><Link to="/fights-schedule/ufc-mma">MMA</Link></li>
      <li className="odds_powered_by d-none d-md-block">powered by<span>mvpboxing.com</span></li>
    </ul>{/* ends (.sch_tabs) */}
    <div className="odds-div">
      <table id="schedules" data-schedulestype="boxing" className="display" style={{width: '100%'}}>
        <thead>
          <tr>
            <th className="oddsText"><h2 style={{fontSize: 20, fontWeight: '700 !important'}}>
                Upcoming							Fight Schedules</h2></th>
            <th style={{display: 'none'}}>Date</th>
            <th style={{display: 'none'}}>Fighter1</th>
            <th style={{display: 'none'}}>Fighter2</th>
            <th style={{display: 'none'}}>Fight Event</th>
            <th style={{display: 'none'}}>Location Time</th>
          </tr>
        </thead>
      </table>
    </div>
    <div className="odds-div">
      <table id="schedules-old" data-schedulestype="boxing" className="display" style={{width: '100%'}}>
        <thead>
          <tr>
            <th className="oddsText"><h2 style={{fontSize: 20, fontWeight: '700 !important'}}>
                Previous							Fight Schedules</h2></th>
            <th style={{display: 'none'}}>Date</th>
            <th style={{display: 'none'}}>Fighter1</th>
            <th style={{display: 'none'}}>Fighter2</th>
            <th style={{display: 'none'}}>Fight Event</th>
            <th style={{display: 'none'}}>Location Time</th>
          </tr>
        </thead>
      </table>
    </div>
    <div className="odds_pager">
      <ul className="sch_tabs">
        <li className="odds_powered_by d-block d-md-none">powered by <span style={{display: 'inline-block'}}>mvpboxing.com</span></li>
      </ul>
      <div className="clear" />
    </div>{/* ends (.odds_pager) */}
    <div className="content-separator">&nbsp;</div>{/* ends (.content-separator) */}
    <div className="socialInfo">
      {/* <div class="left back-to-info">
						<a href="javascript:void(0);" id="goTop" title="Back To Top"><i class="fa fa-arrow-circle-up" aria-hidden="true"></i></a>
					</div> */}
      <div className="text-center social-sharing-info bottom-social-share">
        <p className="social-share-block">
          <i className="share-icon fas fa-share-alt" aria-hidden="true" />
          {/* AddToAny BEGIN */}
          <span className="social-icons a2a_kit a2a_kit_size_32 a2a_default_style">
            <a className="a2a_button_facebook" href="#" title="Facebook" />
            <a className="a2a_button_twitter" href="#" title="Twitter" />
            <a className="a2a_button_whatsapp" href="#" title="WhatsApp" />
            <a className="a2a_button_facebook_messenger" href="#" title="Facebook Messenger" />
            <a className="a2a_button_reddit" href="#" title="Reddit" />
            <a className="a2a_button_pinterest" href="#" title="Pinterest" />
            <a className="a2a_button_email" href="#" title="Email" />
          </span>
          {/* AddToAny END */}				</p>
      </div>
    </div>{/* ends (.social-sharing-info) */}
    <div className="clear" />
    {/* <div class="mvp-comment-box"></div> */}
    {/* ends (.mvp-comment-box) */}
    <div id="comment-policy" className="comment-policy publisher-anchor-color  ">
      <div className="content">
        <h2 className="title">MVPBOXING.COM Comment Policy
          <i aria-hidden="true" className="fa fa-5x fa-comments-o " />
        </h2>
        <p>"Hey, why isn't my comment displaying?!"</p>
        <p>Please read our <a href="/comment_policy" target="_blank" className="policy-link">Comment Policy</a> before commenting.</p>
      </div>
    </div>
    <div className="comments">
      <div className="main-title w-100 row mx-0"><div className="col-7 pl-1"><i className="fa fa-comments-o" aria-hidden="true" /> <span id="total_comments">0</span> <span>Comments</span></div>
        <div id="share-block" className="col-5 text-right pr-1"><i className="fa fa-share-alt" aria-hidden="true" /> Share</div>
      </div>
      <div className="comment-block">
        <div className="social-share-block" style={{display: 'none'}}>
          {/* AddToAny BEGIN */}
          <span className="social-icons a2a_kit a2a_kit_size_32 a2a_default_style">
            <a className="a2a_button_facebook" href="#" title="Facebook" />
            <a className="a2a_button_twitter" href="#" title="Twitter" />
            <a className="a2a_button_whatsapp" href="#" title="WhatsApp" />
            <a className="a2a_button_facebook_messenger" href="#" title="Facebook Messenger" />
            <a className="a2a_button_reddit" href="#" title="Reddit" />
            <a className="a2a_button_pinterest" href="#" title="Pinterest" />
            <a className="a2a_button_email" href="#" title="Email" />
          </span>
          {/* AddToAny END */}		</div>
        <div className="mvp-comment-box comments-container" id="comments-container" style={{border: '1px solid #cccccc', backgroundColor: '#ffffff', minHeight: 120, margin: 15, borderRadius: '3px 3px 3px 3px', fontWeight: 'bold', fontStyle: 'italic', paddingTop: 29}}>MVPBoxing Commenting <br />coming soon.!</div>
        {/* ends (.content-separator2) */}
      </div>
    </div>
  </div>{/* ends (.socialInfo) */}
</div>

    </div>

    
    
    </>


  )
};

export default FightSeheduleBoxing;